import { createContext, useContext } from 'react'

interface ScrollContextValue {
  goToPage: (index: number) => void
  currentPage: number
}

export const ScrollContext = createContext<ScrollContextValue>({
  goToPage: () => undefined,
  currentPage: 0,
})

export function useScroll() {
  return useContext(ScrollContext)
}
